import { render } from "./TrafficTypesTab.vue?vue&type=template&id=cf7d7860"
import script from "./TrafficTypesTab.vue?vue&type=script&lang=js"
export * from "./TrafficTypesTab.vue?vue&type=script&lang=js"

import exportComponent from "/jenkins/workspace/acs-centos7-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.19.1.2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__